<script lang="ts" setup>
import type { DynamicAuctionItemList } from '@autobid/strapi-integration/rest/components'
import type { ItemListFiltersState } from '@autobid/ui/composables/carsList/useFilter'
import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useIsMobile } from '@autobid/ui/composables/useIsMobile'
import { CARS_LIST_DEFAULT_SORTING_TYPE } from '@autobid/ui/constants/carsList/CARS_LIST_DEFAULT_SORTING_TYPE'
import { SEARCH_LIST_DEFAULT_SORTING_TYPE } from '@autobid/ui/constants/carsList/SEARCH_LIST_DEFAULT_SORTING_TYPE'
import { SORTING_TYPES } from '@autobid/ui/constants/carsList/SORTING_TYPES'
import { injectFilterComposable } from '@autobid/ui/utils/carsList/injectFilterComposable'
import { MenuItem } from '@headlessui/vue'
import { computed, inject } from 'vue'

const isMobile = useIsMobile()

const auctionStrapiData = inject<DynamicAuctionItemList>('auction-strapi-data')
const useFilter = injectFilterComposable()
const {
  filters: { sortingType },
} = useFilter()
const { isAuthed } = useAutobidAuth()

const currentValue = computed(() => {
  const value = sortingType.value

  if (sortingType.value && String(sortingType.value) !== 'undefined')
    return value

  return auctionStrapiData?.type === 'carList'
    ? CARS_LIST_DEFAULT_SORTING_TYPE
    : SEARCH_LIST_DEFAULT_SORTING_TYPE
})

const filteredSortingTypes = computed(() => {
  return SORTING_TYPES.filter((el) => {
    if (el.includes('auctionStartDate') && auctionStrapiData?.type === 'carList')
      return false

    if (el.includes('price.current') && !isAuthed.value)
      return false

    return true
  })
})

function handleFilter(newValue: ItemListFiltersState['sortingType']) {
  sortingType.value = newValue
}
</script>

<template>
  <common-dropdown :x="isMobile ? 'left' : 'right'">
    <template #button>
      <span
        class="rounded-md bg-primary p-1 text-white transition hover:scale-105 hover:bg-primaryDark"
      >
        <Icon class="flex" mode="css" name="mi:sort" size="28" />
      </span>
    </template>

    <template #items>
      <ul class="py-2">
        <li
          v-for="loopSortingType in filteredSortingTypes"
          :key="loopSortingType"
        >
          <MenuItem>
            <span
              class="block w-full cursor-pointer px-4 text-base hover:bg-primary hover:text-white"
              :class="{
                'bg-primaryDark text-white': currentValue === loopSortingType,
              }"
              @click="handleFilter(loopSortingType)"
            >
              {{ $t(`cars-list.sorting.${loopSortingType}`) }}
            </span>
          </MenuItem>
        </li>
      </ul>
    </template>
  </common-dropdown>
</template>
